module.exports = __webpack_public_path__ + "static/img/zhong.a6bc55bd.png";